import { Controller } from "stimulus";
import { formatMoney } from "../helpers/formatMoney";
export default class extends Controller {
  static targets = [
    "paymentFee",
    "paymentMethod",
    "installments",
    "installmentsContainer",
    "procedureAmount",
    "netAmountText",
    "expiresDate",
    "transactionDate",
    "infoMessagePayment",
    "submitButton",
    "paymentFeeEmptyError"
  ];

  connect() {
    this.installments = [];
    this.debitFee = null;
    this.paymentFeeName = "";
    this.currentPaymentFeeId = null;
    this.selectedPaymentMethod = null;
    this.submitButtonContent = this.submitButtonTarget.innerHTML;
    this.installmentsTarget.addEventListener('invalid', this.handleValidation)
  }

  tearDown() {
    this.installmentsTarget.removeEventListener('invalid', this.handleValidation)
  }

  get hasFees() {
    return JSON.parse(this.data.get("hasFees"))
  }

  handleValidation(e) {
    e.preventDefault();
    e.currentTarget.focus();
    e.currentTarget.classList.add('reveal-validation');
  }

  validatePaymentFeeForm(event) {
    const hasError = this.hasFees
      && !this.currentPaymentFeeId
      && (this.selectedPaymentMethod === "credit_card" || this.selectedPaymentMethod === "debit_card")
    if (!hasError) return
    event.preventDefault();
    event.stopPropagation();
    this.submitButtonTarget.innerHTML = this.submitButtonContent
    this.submitButtonTarget.disabled = false
    this.paymentFeeEmptyErrorTarget.classList.remove("tw-hidden")
    $(this.element.querySelector(`.debt-payment-method__input[value="${this.selectedPaymentMethod}"]`).nextElementSibling).dropdown("toggle")
  }

  handlePaymentFeeChange(event) {
    this.currentPaymentFeeId = event.currentTarget.value;
    this.installments = [];
    if (this.selectedPaymentMethod === "credit_card" && this.currentPaymentFeeId) {
      this.installmentsContainerTarget.classList.remove("tw-hidden");
      this.installments = JSON.parse(
        event.currentTarget.getAttribute("data-installments")
      );
      this.insertInstallments(this.installments);
    } else {
      this.installmentsContainerTarget.classList.add("tw-hidden");
    }
    this.debitFee = event.currentTarget.getAttribute("data-debit-fee")
    this.paymentFeeName = event.currentTarget.getAttribute("data-name");
    this.updateInterfaceInputs();
  }

  handlePaymentMethodClick(event) {
    const checkbox = event.currentTarget.previousElementSibling
    if (this.selectedPaymentMethod === checkbox.value) return
    this.selectedPaymentMethod = checkbox.value
    checkbox.checked = true
    checkbox.dispatchEvent(new Event('change'))
  }

  handlePaymentMethodChange(event) {
    const paymentMethod = event.currentTarget;
    this.paymentFeeTargets.map(paymentFee => paymentFee.checked = false)
    this.currentPaymentFeeId = null
    this.debitFee = null;
    this.paymentFeeName = "";
    this.selectedPaymentMethod = paymentMethod.value
    this.updateInterfaceInputs();
  }

  updateInterfaceInputs() {
    const hasInstallments = this.selectedPaymentMethod === "credit_card" && this.currentPaymentFeeId
    const hasDebitWithFee = this.selectedPaymentMethod === "debit_card" && this.currentPaymentFeeId
    this.paymentFeeEmptyErrorTarget.classList.add("tw-hidden")
    this.installmentsContainerTarget.classList.toggle("tw-hidden", !hasInstallments);
    this.infoMessagePaymentTarget.classList.toggle("tw-hidden", !this.currentPaymentFeeId);
    this.installmentsTarget.toggleAttribute("required", hasInstallments);
    this.netAmountTextTarget.classList.toggle("tw-hidden", !hasInstallments);

    if (hasInstallments) {
      this.updateNetAmountText(this.installments[0].number, this.installments[0].fee );
    }

    if (hasDebitWithFee) {
      this.handleDebitFeeChange(this.totalAmount, this.debitFee);
      this.netAmountTextTarget.classList.remove("tw-hidden");
      this.netAmountTextTarget.classList.add("tw-flex");
    }
  }

  handleUpdateAmount() {
    if (this.installments.length === 0) return;
    this.insertInstallments(this.installments);
  }

  handleInstallmentSelect(event) {
    const installment = this.installments.find(
      installment => installment.number == event.currentTarget.value
    );
    this.updateNetAmountText(installment.number, installment.fee);
    this.netAmountTextTarget.classList.remove("tw-hidden");
    this.expiresDateTargets.map(expiresDate => {
      expiresDate.toggleAttribute("disabled", installment.number > 1)
    })
    this.transactionDateTarget.toggleAttribute("required", installment.number > 1)
  }

  get totalAmount() {
    if (this._totalAmount) {
      return this._totalAmount;
    }
    this._totalAmount = this.procedureAmountTargets.reduce(
      (accumulator, procedureAmount) => {
        return accumulator + Number(procedureAmount.value.replace(",", "."));
      },
      0
    );

    return this._totalAmount;
  }

  updateNetAmountText(installment, fee) {
    const totalAmount = this.totalAmount;
    const netAmount = (totalAmount * (100 - fee)) / 100;
    this.netAmountTextTarget.children[1].innerHTML = `<span class="tw-font-semibold">Você receberá ${formatMoney(netAmount)}</span> - Parcelado em ${installment}x ${this.paymentFeeName} com taxa de ${String(fee).replace(".", ",")}%`
  }

  handleDebitFeeChange(totalAmount, fee) {
    const netAmount = totalAmount * (100 - fee) / 100
    this.netAmountTextTarget.children[1].innerHTML = `<span class="tw-font-semibold">Você receberá ${formatMoney(netAmount)}</span> - Débito ${this.paymentFeeName} com taxa de ${String(fee).replace(".", ",")}%`
  }

  insertInstallments(installments) {
    const totalAmount = this.totalAmount;
    const selectedValue = this.installmentsTarget.value
      ? Number(this.installmentsTarget.value)
      : null;
    const installmentsOptions = installments.map(installment => {
      return `<option value="${installment.number}">${installment.number}x - ${
        installment.fee
      }% (${formatMoney(totalAmount / installment.number)})</option>`;
    });

    this.installmentsTarget.innerHTML = "<option value='' selected disabled>Selecionar</option>" + installmentsOptions.join("");
    if (selectedValue) {
      this.installmentsTarget.value = selectedValue;
    }
  }
}
